<template>
    <BaseLayout :seo="seo">
<!--        <Breadcrumbs :items="[]"/>-->

        <!--        TODO: remove after promo         -->
<!--        <Promocode/>-->

        <ProductsListWithFilters
            :list-title="category.title"
            :base-url="route('categories.show', {category})"
            :products="products"
            :sub-categories="subCategories"
            :sub-categories-title="subCategoriesTitle"
            :filters="filters"
            :active-filters="activeFilters"
            :footer-description="seo.footer_description"
        />
    </BaseLayout>
</template>

<script>
import {defineComponent} from 'vue'
import BaseLayout from "@/Layouts/BaseLayout.vue";
import ProductsListWithFilters from "@/Components/Products/ProductsListWithFilters.vue";
import Breadcrumbs from '@/Components/Breadcrumbs.vue';
// import Promocode from "@/Components/Promocode.vue";

export default defineComponent({
    components: {
        Breadcrumbs,
        ProductsListWithFilters,
        // Promocode,
        BaseLayout
    },
    props: {
        seo: Object,
        category: Object,
        products: Object,
        filters: Array,
        activeFilters: Object,
        subCategories: Object,
        subCategoriesTitle: String,
    },
})
</script>
